import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useDrawer } from 'ducks/drawers/hooks'
import { doOpenDrawer } from 'ducks/drawers/actions'
import selectIntegrationData from 'ducks/integrations/selectors/settings/selectIntegrationData'
import { useFetchIntegrationProvider } from 'ducks/integrations/hooks'
import { DRAWER_TYPE_INTEGRATION_INSTALL } from 'ducks/drawers/types'
import useIntegrationDrawers from 'subapps/settings/components/IntegrationsDataTable/useIntegrationDrawers'
import { selectCurrentPage } from 'selectors/location'
import { SETTINGS_INTEGRATIONS_PAGE } from 'subapps/settings/types'
import Menu from './Menu'
import ButtonWithMenu from '../ButtonWithMenu'

const IntegrationsSection = ({ className }) => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()
  const [providerId, setProviderId] = useState()
  const integrationData = useSelector(selectIntegrationData)
  const isActive = useSelector(selectCurrentPage) === SETTINGS_INTEGRATIONS_PAGE
  const { onAccessIntegration } = useIntegrationDrawers()

  const {
    isLoading,
    isAlreadyInstalled,
    isMissing,
  } = useFetchIntegrationProvider(providerId)

  const { openDrawer: openInstallDrawer } = useDrawer(
    DRAWER_TYPE_INTEGRATION_INSTALL
  )

  const handleAccessIntegration = useCallback(
    id => {
      setProviderId(null)
      const integrationConfig = integrationData.find(
        integration => integration.id === id
      )
      if (!integrationConfig) return
      const shouldHandleClick = onAccessIntegration({
        id,
        integrationConfig,
        isInstalled: isAlreadyInstalled,
      })
      if (!shouldHandleClick) return
      const {
        installActionTypeConfig: {
          skipOverview = false,
          drawerType: installDrawerType,
        } = {},
      } = integrationConfig
      if (!skipOverview) {
        openInstallDrawer(id)
      } else {
        dispatch(doOpenDrawer(id, installDrawerType, id))
      }
    },
    [
      integrationData,
      dispatch,
      openInstallDrawer,
      isAlreadyInstalled,
      onAccessIntegration,
    ]
  )

  const handleCloseMenu = useCallback(() => {
    setOpen(false)
  }, [])

  const handleClickIntegration = useCallback(
    id => {
      handleCloseMenu()
      setProviderId(id)
    },
    [handleCloseMenu]
  )

  const overlay = useMemo(
    () => (
      <Menu
        onClose={handleCloseMenu}
        handleClickIntegration={handleClickIntegration}
      />
    ),
    [handleCloseMenu, handleClickIntegration]
  )

  useEffect(
    () => {
      if (!isMissing && !isLoading && providerId) {
        handleAccessIntegration(providerId)
      }
    },
    [isMissing, isLoading, handleAccessIntegration, providerId]
  )

  return (
    <ButtonWithMenu
      css={className}
      isActive={isActive}
      open={open}
      setOpen={setOpen}
      overlay={overlay}
    >
      Powerup
    </ButtonWithMenu>
  )
}

export default IntegrationsSection
